import { Pillar, Region, Service } from "../model/domain.model";

export interface NotificationsList{
  notifications: Notification[];
  frequencies : string[];
  clientRights : ClientRights;
}

export interface Notification {

  frequency : string;
  id : string;
  pillars : Pillar[];
  regions : Region[];
  services : Service[];

}

export interface ClientRights{
  serviceRights : ServiceRight[];
}

export interface ServiceRight{
  service : Service;
  regionRights : RegionRight[];
  pillarRights : PillarRight[];
}

export interface RegionRight{
  region : Region;
}

export interface PillarRight{
  pillar : Pillar;
}

export class NotificationToBeAddedDto {

  frequency : string;
  pillars : string[];
  regions : string[];
  services : string[];

}

